import { getQuarter } from 'date-fns';
import queryString from 'query-string';
import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { setLoading, setSuccess } from '../../../actions/loadingActions';
import { quarters, years } from '../../../constants/generals';
import { IFilters, IHistory, IQuarterlyForms } from '../../../interfaces';
import { QuarterlyFormModel } from '../../../model/QuarterlyFormModel';
import { getQuarterlyFormList } from '../../../services/quarterlyFormService';
import { BasePage } from '../../reusableComponents/BasePage';
import { BarChart } from '../../reusableComponents/ChartComponents/BarChart';
import { PieChart } from '../../reusableComponents/ChartComponents/PieChart';
import { ListPage } from '../../reusableComponents/ListPage';
import { RegionFilter } from '../../reusableComponents/RegionFilter';
import { SelectDropdown } from '../../reusableComponents/SelectDropdown';
import { ListItem } from './ListItem';

export interface IQuarterlyReportsProps {
    instances: QuarterlyFormModel[];
    quarterlyForms: IQuarterlyForms;
    filters: IFilters;
    history: IHistory;
    location: any;
}

export interface IQuarterlyReportsState {
    filterBy: string;
    year: string;
    quarter: string;
    region: string;
}

export class QuarterlyReportsImpl extends React.Component<IQuarterlyReportsProps, IQuarterlyReportsState> {
    constructor(props: IQuarterlyReportsProps) {
        super(props);
        let year = new Date().getFullYear().toString();
        let region = 'All';
        let quarter = getQuarter(new Date()).toString();
        if (this.props.location.search) {
            year = queryString.parse(this.props.location.search).year;
            quarter = queryString.parse(this.props.location.search).quarter;
            region = queryString.parse(this.props.location.search).region;
        }
        this.state = {
            region,
            filterBy: '',
            year, quarter
        };
    }

    promise = async () => {
        let year = new Date().getFullYear().toString();
        let region = 'All';
        let quarter = getQuarter(new Date()).toString();
        if (this.props.location.search) {
            year = queryString.parse(this.props.location.search).year;
            quarter = queryString.parse(this.props.location.search).quarter;
            region = queryString.parse(this.props.location.search).region;
        }
        await getQuarterlyFormList(quarter, year, 'All', region);
    }

    renderLineChart = () => {
        const { quarterlyForms } = this.props;
        if (!quarterlyForms) {
            return <div></div>;
        }

        const quarterlyFormsData = [];
        quarterlyFormsData.push({
            name: 'Quarter Visual', 'Complete Forms': quarterlyForms.QTRVisual.Complete,
            'Incomplete Forms': quarterlyForms.QTRVisual.InComplete
        });
        quarterlyFormsData.push({
            name: 'ShopInspection', 'Complete Forms': quarterlyForms.ShopInspection.Complete,
            'Incomplete Forms': quarterlyForms.ShopInspection.InComplete
        });
        return <Row className="show-grid line-chart-container" style={{ display: 'flex', justifyContent: 'center' }} >
            <Col sm={6} xs={12}  >
                <BarChart
                    barColors={['#63AB66', '#DBDBDB']}
                    dataKey={['Complete Forms', 'Incomplete Forms']}
                    data={quarterlyFormsData}
                />
            </Col>
        </Row>;
    }

    renderPieChart = () => {
        const { quarterlyForms } = this.props;
        if (!quarterlyForms) {
            return <div></div>;
        }
        const { filterBy } = this.state;
        const dailyFormSummary =
            [{ name: 'Complete Forms', value: quarterlyForms[filterBy].Complete },
            { name: 'Incomplete Forms', value: quarterlyForms[filterBy].InComplete }];

        return <Row className="show-grid">
            <Col sm={12} xs={12} className="pie-chart-container" >
                <PieChart className="pie-chart-responsive" data={dailyFormSummary} dataKey="value" legends >
                </PieChart>
            </Col>
        </Row>;
    }

    handleRegionFilter = async (a, value) => {
        setLoading('QuarterlyFormList');
        const { quarter, year } = this.state;
        this.setState({ region: value });
        const queryString = `?year=${year}&&quarter=${quarter}&&region=${value}`;
        await getQuarterlyFormList(quarter.toString(), year, '', value);
        this.props.history.push(`/reports/quarterly${queryString}`);
        setSuccess('QuarterlyFormList');
    }

    handleQuarterFilter = async (value) => {
        setLoading('QuarterlyFormList');
        const { year, region } = this.state;
        this.setState({ quarter: value });
        const queryString = `?year=${year}&&quarter=${value}&&region=${region}`;
        await getQuarterlyFormList(value, year, '', this.state.region);
        this.props.history.push(`/reports/quarterly${queryString}`);
        setSuccess('QuarterlyFormList');
    }

    handleYearFilter = async (value) => {
        setLoading('QuarterlyFormList');
        const { quarter, region } = this.state;
        this.setState({ year: value });
        const queryString = `?year=${value}&&quarter=${quarter}&&region=${region}`;
        await getQuarterlyFormList(quarter.toString(), value, '', this.state.region);
        this.props.history.push(`/reports/quarterly${queryString}`);
        setSuccess('QuarterlyFormList');
    }

    render() {
        const { instances } = this.props;
        const { filterBy } = this.state;
        return (
            <BasePage className="list-page-base" pageTitle="Quarterly Reports" >
                <ListPage
                    identifier="QuarterlyFormList"
                    instances={instances}
                    listItemComponent={ListItem}
                    searchBy={['Region', 'PlantId', 'type', 'Date']}
                    instanceOf={'plantInfo'}
                    pageHeadings={['#', 'Plant ID', 'Region', 'Type', 'Submitted Date','Updated Date']}
                    promise={this.promise}
                    cols={[1, 2, 2, 2, 3, 2]}
                    searchPlaceHolder="Enter date, plant or form type to search..."
                    emptyListMessage="No Quarterly Reports found"
                    chartComponents={filterBy && filterBy !== 'all' ? this.renderPieChart() : this.renderLineChart()}
                    chartTitle="Quarterly Forms"
                    filterBy={filterBy}
                    chartFilter={<div className="filter-container" >
                        <RegionFilter
                            selectedValue={this.state.region}
                            onChange={this.handleRegionFilter}
                        />
                        <SelectDropdown
                            placeholder="Quarter"
                            defaultValue={this.state.quarter}
                            onChange={this.handleQuarterFilter}
                            menuItems={quarters()}
                        />
                        <SelectDropdown
                            placeholder="Year"
                            onChange={this.handleYearFilter}
                            defaultValue={this.state.year}
                            menuItems={years()}
                        />
                    </div>}
                />
            </BasePage>
        );
    }
}

export function mapStateToProps(state) {
    const instances = QuarterlyFormModel.list(state);
    return {
        instances,
    };
}

export const QuarterlyReports =
    withRouter(connect<{}, {}, IQuarterlyReportsProps>(mapStateToProps)(QuarterlyReportsImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Reports/Quarterly/QuarterlyReports.tsx